import { render } from "./FriendsAddItem.vue?vue&type=template&id=f7680e9e&scoped=true"
import script from "./FriendsAddItem.vue?vue&type=script&lang=js"
export * from "./FriendsAddItem.vue?vue&type=script&lang=js"

import "./FriendsAddItem.vue?vue&type=style&index=0&id=f7680e9e&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7680e9e"]])

export default __exports__